import gql from 'graphql-tag'
import { Course } from '~/graphql/fragments/course.js'
import { User } from '~/graphql/fragments/user.js'

export const ACADEMY_SCHEDULE = gql`
  query academySchedule($fromDate: Date!, $toDate: Date!) {
    academySchedule(fromDate: $fromDate, toDate: $toDate) {
      startDate
      course {
        id
        userId
        name
        slug
        cover
        objectives
        desc
        enrolled
        courseEnrolls {
          userId
          minutesPerDay
          estimateTime
          status
        }
        published
        publishedAt
        trainer {
          id
          name
          media {
            id
            url
          }
        }
        courseMedias {
          id
          media {
            id
            fileName
            source
            url
            thumbnail
            thumbnailHigh
            status
          }
          transcript
        }
      }
      topicEnrolls {
        currentTime
        estimateEndAt
        estimateStartAt
        startAt
        score
        status
        topic {
          id
          name
          desc
          mediaFromTime
          mediaToTime
          media {
            id
            fileName
            source
            url
            thumbnail
            thumbnailHigh
            status
          }
          topicType
          desc
          shortDesc
        }
      }
    }
  }
`

export const ACADEMY_SCHEDULE_INFO = gql`
  query academyScheduleInfo($slug: String!) {
    academyScheduleInfo(slug: $slug) {
      id
      startDate
      endDate
      status
      completedAt
      completedOnSchedule
      class {
        videoLink
      }
      minutesPerDay
      approval {
        ...User
      }
      course {
        ...Course
      }
      userId
      topicEnrolls {
        currentTime
        estimateStartAt
        startAt
        score
        status
        topic {
          id
          name
          desc
          slug
          mediaFromTime
          mediaToTime
          media {
            id
            fileName
            source
            url
            scormMediaId
            thumbnail
            thumbnailHigh
            status
          }
          content {
            questions {
              id
              options {
                id
                right
                title
                media {
                  url
                  id
                }
              }
              title
              type
              desc
              media {
                url
                id
              }
            }
          }
          topicType
          desc
          shortDesc
        }
        contentResponse {
          questions {
            questionId
            title
            desc
            type
            media {
              id
              url
            }
            options {
              optionId
              title
              selected
              media {
                id
                url
              }
            }
          }
        }
      }
      user {
        ...User
      }
    }
  }
  ${Course}
  ${User}
`

export const ACADEMY_SCHOOL_SCHEDULE = gql`
  query academySchoolSchedule($schoolId: Int!, $fromDate: Date!, $toDate: Date!) {
    academySchoolSchedule(schoolId: $schoolId, fromDate: $fromDate, toDate: $toDate) {
      date
      state
      userId
      course {
        name
        id
        topics {
          id
          name
          desc
          topicType
          mediaFromTime
          mediaToTime
        }
      }

      startDate
      endDate
      completedPercent
      completedOn
      completedOnSchedule
    }
  }
`

export const GET_APPRAISAL_SCHEDULES = gql`
  query appraisalSchedules($schoolId: Int!) {
    appraisalSchedules(schoolId: $schoolId) {
      endDate
      id
      name
      startDate
    }
  }
`

export const GET_APPRAISAL_REVIEW_PROCESS = gql`
  query appraisalReviewProcess($schoolId: Int!) {
    appraisalReviewProcess(schoolId: $schoolId) {
      changesToFinalised
      lock
      masterLocked
      schoolId
      showHideContent
    }
  }
`
